module.exports = __webpack_public_path__ + "img/guahao.fbb4a8ad.png";